<template>
  <div class="product__selections">
    <product-variations
      ref="productVariations"
      :attributes="attributes"
      :variations="variations"
      @change="variationsChanged"
    />


    <product-mandatory-add-ons
      ref="productMandatoryAddOns"
      :add-ons="mandatoryProductAddOns"
      :hide-prices="hidePrices"
      @change="mandatoryAddOnsChanged"
    />

    <product-add-ons
      ref="productAddOns"
      :add-ons="productAddOns"
      :hide-prices="hidePrices"
      @change="addOnsChanged"
    />

    <div
      v-if="view != 'modal'"
      class="product__availability-container"
    >
      <p
        v-if="availability"
        class="availability"
        :class="availability.status ? 'availability--' + availability.status : ''"
      >
        {{ availability.text }}
        <span
          v-if="availability.detail"
          class="availability__detail"
        >{{ availability.detail }}</span>
      </p>
      <p
        v-if="inShowroom"
        class="availability availability--positive"
      >
        {{ $modeoL10n.in_showroom }}
        <span class="availability__detail">{{ $modeoL10n.in_showroom_disclaimer }}</span>
      </p>
    </div>

    <div
      v-if="showPrice"
      class="product__price-container price-container"
    >
      <div
        v-if="hasSelections()"
        class="product__price-heading"
      >
        <span class="product__price-heading__text">{{ $modeoL10n.in_total }}</span>
        (<button
          class="link"
          @click="clearSelections()"
        >
          {{ $modeoL10n.clear_selections }}
        </button>)
      </div>
      <div class="price price--big">
        <div class="price-amount-container price-amount-container--big">
          <span
            class="price-amount product__price-amount"
            :class="{ 'price-amount--ins': total_price_with_tax != total_regular_price_with_tax }"
          ><price
            :price-with-tax="total_price_with_tax"
            :price-without-tax="total_price_without_tax"
          /></span>
          <span
            v-if="total_price_with_tax != total_regular_price_with_tax"
            class="price-amount price-amount--del product__price-amount"
          ><price
            :price-with-tax="total_regular_price_with_tax"
            :price-without-tax="total_regular_price_without_tax"
          /></span>
        </div>

        <div class="price-details price-details--big">
          <span
            class="tax tax--big"
            :class="{ 'tax--highlight tax--highlight-big': (product.outlet && !$store.getters.showPricesWithVat) }"
          >{{ $modeoL10n.vat }} {{ $store.getters.displayVat }}</span>
          <template v-if="!disableBuying">
            <product-counter
              ref="productCounter"
              :counter-mode="'big'"
              :max-count="maxCount()"
              @update="addToCartWithCount($event)"
              @change="changeCount($event)"
            />
            <button
              v-if="orderType == 'order'"
              class="product__buy btn btn--buy"
              :disabled="addToCartDisabled"
              @click.stop="addToCart()"
            >
              {{ $modeoL10n.buy }}
            </button>
            <button
              v-if="orderType == 'offer' && view != 'modal'"
              class="product__buy btn btn--buy"
              :disabled="addToCartDisabled"
              @click.stop="addToCart()"
            >
              {{ $modeoL10n.add }}
            </button>
          </template>
        </div>
      </div>
    </div>

    <div
      v-if="$modeoL10n.url_rfp && disableBuying"
      class="conversion-mini"
    >
      <div class="conversion-mini__content-column">
        <h2 class="conversion-mini__heading">
          {{ $modeoL10n.ask_more_about_product }}
        </h2>
      </div>
      <a
        :href="$modeoL10n.url_rfp + '?tuote=' + encodeURI($modeoL10n.interested_in_following_products + ': ' + product.name)"
        class="btn btn--secondary btn--secondary-med btn--secondary-forward conversion-mini__button"
      >{{ $modeoL10n.contact_us }}</a>
    </div>
    <klarna-placement
      data-key="credit-promotion-badge"
      :data-locale="klarnaLocale()"
      data-preloaded="true"
      :data-purchase-amount="this.$store.getters.showPricesWithVat ? total_price_with_tax * 100 : parseInt(total_price_without_tax * 100)"
    />
  </div>
</template>

<script>
    import ProductCounter from './product-counter.vue';
    import ProductAddOns from './product-add-ons.vue';
    import ProductMandatoryAddOns from './product-mandatory-add-ons.vue';
    import ProductVariations from './product-variations.vue';
    import { EventBus } from '../../event-bus.js';
    import axios from 'axios';
    import _ from 'lodash';

    export default {
        components: {
            ProductCounter,
            ProductAddOns,
            ProductMandatoryAddOns,
            ProductVariations,
        },
        props: {
            productId: {
                type: Number,
                default: 0,
            },
            product: {
                type: Object,
                default: function () {
                    return {};
                },
            },
            variations: {
                type: Array,
                default: function () {
                    return [];
                },
            },
            attributes: {
                type: Array,
                default: function () {
                    return [];
                },
            },
            productAddOns: {
                type: Array,
                default: function () {
                    return [];
                },
            },
            mandatoryProductAddOns: {
                type: Array,
                default: function () {
                    return [];
                },
            },
            hidePrices: Boolean,
            orderType: {
                type: String,
                default: '',
            },
            view: {
                type: String,
                default: '',
            },
            nonce: {
                type: String,
                default: '',
            },
            disableBuying: Boolean,
        },
        data : function () {
            return {
                count : 1,
                selected_variation : null,
                selected_variation_id: null,
                add_on_selections: {},
                add_on_total_with_tax: 0,
                add_on_total_without_tax: 0,
                add_on_regular_price_total_with_tax: 0,
                add_on_regular_price_total_without_tax: 0,
                mandatory_add_on_selections: {},
                mandatory_add_on_total_with_tax: 0,
                mandatory_add_on_total_without_tax: 0,
                mandatory_add_on_regular_price_total_with_tax: 0,
                mandatory_add_on_regular_price_total_without_tax: 0,
                selections : {},
                price_with_tax: 0,
                price_without_tax: 0,
                regular_price_with_tax: 0,
                regular_price_without_tax: 0,
                total_price_with_tax: 0,
                total_price_without_tax: 0,
                total_regular_price_with_tax: 0,
                total_regular_price_without_tax: 0,
                showAddOns: false,
                lowestStock: 0,
                longestDeliveryTime: null,
                updatedNonce: false,
                componentInitTime: new Date(),
                someInStockThreshold: 10, //TODO FROM ENV
                outOfStockThreshold: 0, //TODO FROM ENV
                defaultDeliveryTime: 14, //TODO FROM ENV
            };
        },

        computed: {


            hasVariations() {
                return this.variations.length > 0;
            },

            inShowroom() {
                //If main product or any variations are in showroom, let's return true
                if (this.product.showroom) {
                    return true;
                }

                if (this.variations.length > 0) {
                    return this.variations.some( (variation) => {
                        return variation.showroom
                    });
                }

                return false;
            },

            showPrice() {

                if (this.total_price_with_tax <= 0 || isNaN(this.total_price_with_tax)) {
                    return false;
                }

                if (this.hidePrices) {
                    return false;
                }

                return !(this.outOfStock && this.getManageStock() && this.getBackorders() === 'no');


            },

            addToCartDisabled() {
                return this.variations.length > 0 && !this.selected_variation;

            },

            stockQuantity() {
                if (this.variations.length > 0 && this.selected_variation) {
                    return this.selected_variation.stock_quantity;
                } else {
                    return this.product.stock_quantity;
                }
            },

            enoughInStock() {
                return (this.lowestStock - this.count) > this.someInStockThreshold;
            },

            someInStock() {
                return (this.lowestStock - this.count) >= this.outOfStockThreshold && (this.lowestStock - this.count) <= this.someInStockThreshold;
            },

            outOfStock() {
                return (this.lowestStock - this.count) < this.outOfStockThreshold;
            },

            deliveryTime() {
                if (this.variations.length > 0 && this.selected_variation.estimated_delivery_time) {
                    return this.selected_variation.estimated_delivery_time;
                } else if (this.product.estimated_delivery_time) {
                    return this.product.estimated_delivery_time;
                } else {
                    return this.defaultDeliveryTime;
                }
            },

            availability() {
                if (this.product.outlet) {
                    let availabilityStock = this.lowestStock ? this.lowestStock + ' ' + (this.lowestStock == 1 ? this.$modeoL10n.item : this.$modeoL10n.items) : false;
                    return {'status': 'positive', 'text': this.$modeoL10n.in_outlet, 'detail': availabilityStock};
                } else if (!this.showPrice || this.disableBuying) {
                    return {'status': false, 'text': this.$modeoL10n.sale_to_order, 'detail': false};
                } else if (this.enoughInStock) {
                    return {'status': 'positive', 'text': this.$modeoL10n.in_stock, 'detail': false};
                } else if (this.someInStock) {
                    if (this.lowestStock < 3) {
                      let availabilityStock = this.lowestStock + ' ' + (this.lowestStock == 1 ? this.$modeoL10n.item : this.$modeoL10n.items);
                      return {'status': 'positive', 'text': this.$modeoL10n.in_stock, 'detail': availabilityStock};
                    }
                    return {'status': 'positive', 'text': this.$modeoL10n.in_stock, 'detail': this.$modeoL10n.a_few_items};
                } else if (this.outOfStock && this.getBackorders() === 'yes' || this.outOfStock && !this.getManageStock()) {
                    return {'status': 'warning', 'text': this.$modeoL10n.delivery_time + ' ' + this.longestDeliveryTime + ' ' + (this.longestDeliveryTime == 1 ? this.$modeoL10n.week : this.$modeoL10n.weeks), 'detail': false};
                } else if (this.outOfStock && this.getManageStock() && this.getBackorders() === 'no') {
                    return {'status': false, 'text': this.$modeoL10n.out_of_stock, 'detail': false};
                } else {
                    return false;
                }
            },

        },

        mounted: function() {
            this.$refs.productMandatoryAddOns.setDefaultValues();

            if (this.variations.length === 0) {
                this.price_with_tax = this.product.prices_with_tax.price;
                this.price_without_tax = this.product.prices_without_tax.price;
                this.regular_price_with_tax = this.product.prices_with_tax.regular_price;
                this.regular_price_without_tax = this.product.prices_without_tax.regular_price;
                this.updatePrice();
            }

            this.updateMandatoryAddOnTotal();
        },
        methods: {
            maxCount() {
                if ( this.getManageStock() && this.getBackorders() == 'no' && !this.hasVariations ) {
                    return (this.product.stock_quantity > 0) ? this.product.stock_quantity : 0;
                } else if ( this.getManageStock() && this.getBackorders() == 'no' && this.hasVariations ) {
                    return (this.selected_variation.stock_quantity > 0) ? this.selected_variation.stock_quantity : 0;
                }
            },
            variationsChanged(data) {
                this.price_with_tax = data.price_with_tax;
                this.price_without_tax = data.price_without_tax;
                this.regular_price_with_tax = data.regular_price_with_tax;
                this.regular_price_without_tax = data.regular_price_without_tax;
                this.selections = data.selections;
                this.selected_variation = data.selectedVariation;
                this.selected_variation_id = data.selectedVariation.variation_id;

                //Check max count
                if (this.count > this.maxCount()) {
                    this.count = this.maxCount();
                    if (!this.count) {
                        this.count = 1;
                    }
                    if (this.$refs.productCounter) {
                        this.$refs.productCounter.setCount(this.count);
                    }
                }

                EventBus.$emit('variation-changed', this.selected_variation);
                this.calculateStocks();
                this.updatePrice();
            },

            getAllSelectedAddOns() {
                return _.assign({}, this.add_on_selections, this.mandatory_add_on_selections);
            },

            updatePrice() {

                let old_total_price = this.total_price_with_tax;
                let old_total_regular_price = this.total_price_with_tax;

                const add_ons_total_with_tax = this.parseCommaDecimalFormat( this.add_on_total_with_tax ) + this.parseCommaDecimalFormat( this.mandatory_add_on_total_with_tax );
                const add_ons_total_without_tax = this.parseCommaDecimalFormat( this.add_on_total_without_tax ) + this.parseCommaDecimalFormat( this.mandatory_add_on_total_without_tax );
                const add_ons_regular_price_total_with_tax = this.parseCommaDecimalFormat( this.add_on_regular_price_total_with_tax ) + this.parseCommaDecimalFormat( this.mandatory_add_on_regular_price_total_with_tax );
                const add_ons_regular_price_total_without_tax = this.parseCommaDecimalFormat( this.add_on_regular_price_total_without_tax ) + this.parseCommaDecimalFormat( this.mandatory_add_on_regular_price_total_without_tax );

                if (this.variations.length > 0 && this.selected_variation) {
                    this.total_price_with_tax = this.parseCommaDecimalFormat(this.selected_variation.prices_with_tax.price) + add_ons_total_with_tax;
                    this.total_price_without_tax = this.parseCommaDecimalFormat(this.selected_variation.prices_without_tax.price) + add_ons_total_without_tax;

                    this.total_regular_price_with_tax = this.parseCommaDecimalFormat(this.selected_variation.prices_with_tax.regular_price) + add_ons_regular_price_total_with_tax;
                    this.total_regular_price_without_tax = this.parseCommaDecimalFormat(this.selected_variation.prices_without_tax.regular_price) + add_ons_regular_price_total_without_tax;
                } else {
                    this.total_price_with_tax = this.parseCommaDecimalFormat(this.price_with_tax) + add_ons_total_with_tax;
                    this.total_price_without_tax = this.parseCommaDecimalFormat(this.price_without_tax) + add_ons_total_without_tax;

                    this.total_regular_price_with_tax = this.parseCommaDecimalFormat(this.regular_price_with_tax) + add_ons_regular_price_total_with_tax;
                    this.total_regular_price_without_tax = this.parseCommaDecimalFormat(this.regular_price_without_tax) + add_ons_regular_price_total_without_tax;
                }

                if (old_total_price !== this.total_price_with_tax || old_total_regular_price !== this.total_price_with_tax) {
                    EventBus.$emit('total-price-changed', {
                        price_with_tax: this.total_price_with_tax,
                        price_without_tax: this.total_price_without_tax,
                        regular_price_with_tax: this.total_regular_price_with_tax,
                        regular_price_without_tax: this.total_regular_price_without_tax,
                    });
                }
            },

            addOnsChanged(data) {
                this.add_on_selections = data.addOns;
                this.add_on_total_with_tax = data.totals.totalWithTax;
                this.add_on_total_without_tax = data.totals.totalWithoutTax;
                this.add_on_regular_price_total_with_tax = data.totals.totalRegularWithTax;
                this.add_on_regular_price_total_without_tax = data.totals.totalRegularWithoutTax;
                this.calculateStocks();
                this.updatePrice();
            },

            mandatoryAddOnsChanged(data) {
                this.mandatory_add_on_selections = data.addOns;
                this.updateMandatoryAddOnTotal();
            },

            updateMandatoryAddOnTotal() {
                let totalWithTax = 0;
                let totalWithoutTax = 0;
                let regular_price_totalWithTax = 0;
                let regular_price_totalWithoutTax = 0;

                for (let add_on_index in this.mandatory_add_on_selections) {
                    let add_on = this.mandatory_add_on_selections[add_on_index];
                    if (!_.isEmpty(add_on)) {
                        totalWithTax = totalWithTax + this.parseCommaDecimalFormat( add_on.prices_with_tax.price );
                        regular_price_totalWithTax = regular_price_totalWithTax + this.parseCommaDecimalFormat( add_on.prices_with_tax.regular_price );
                        totalWithoutTax = totalWithoutTax + this.parseCommaDecimalFormat( add_on.prices_without_tax.price );
                        regular_price_totalWithoutTax = regular_price_totalWithoutTax + this.parseCommaDecimalFormat( add_on.prices_without_tax.regular_price );
                    }
                }

                this.mandatory_add_on_total_with_tax = totalWithTax;
                this.mandatory_add_on_total_without_tax = totalWithoutTax;
                this.mandatory_add_on_regular_price_total_with_tax = regular_price_totalWithTax;
                this.mandatory_add_on_regular_price_total_without_tax = regular_price_totalWithoutTax;

                this.calculateStocks();
                this.updatePrice();
            },

            calculateStocks() {
                this.lowestStock = this.getLowestStock();
                this.longestDeliveryTime = this.getLongestDeliveryTime();
            },

            /*
             * Loops through main product and add-ons and returns lowest stock amount.
             */
            getLowestStock: function() {
                let lowestStock = 0;
                if (this.variations.length > 0 && this.selected_variation) {
                    lowestStock = this.selected_variation.stock_quantity;
                } else {
                    lowestStock = this.product.stock_quantity;
                }

                //Go through add-ons...
                let addOns = _.values(this.getAllSelectedAddOns());

                for (let i = 0; i < addOns.length; i++) {
                    if (addOns[i] && addOns[i].stock_quantity < lowestStock) {
                        lowestStock = addOns[i].stock_quantity;
                    }
                }
                return lowestStock;
            },

            getBackorders: function() {
                let backorders = 'no';
                if ( this.variations.length > 0 && this.selected_variation ) {
                    backorders = this.selected_variation.backorders;
                } else {
                    backorders = this.product.backorders;
                }
                return backorders;
            },

            getManageStock: function() {
                let manageStock = false;
                if ( this.variations.length > 0 && this.selected_variation ) {
                    manageStock = this.selected_variation.manage_stock;
                } else {
                    manageStock = this.product.manage_stock;
                }
                return manageStock;
            },

            /*
             * Loops through main product and add-ons and returns longest delivery time.
             */
            getLongestDeliveryTime: function() {
                let longestDeliveryTime = 0;

                if (this.variations.length > 0 && this.selected_variation && longestDeliveryTime < this.selected_variation.estimated_delivery_time) {
                    longestDeliveryTime = this.parseCommaDecimalFormat(this.selected_variation.estimated_delivery_time);
                } else if (this.product.estimated_delivery_time && longestDeliveryTime < this.parseCommaDecimalFormat(this.product.estimated_delivery_time) ) {
                    longestDeliveryTime = this.parseCommaDecimalFormat(this.product.estimated_delivery_time);
                }

                //Go through add-ons...
                let addOns = _.values(this.getAllSelectedAddOns());

                for (let i = 0; i < addOns.length; i++) {
                    if (addOns[i] && this.parseCommaDecimalFormat(addOns[i].estimated_delivery_time) > longestDeliveryTime) {
                        longestDeliveryTime = this.parseCommaDecimalFormat(addOns[i].estimated_delivery_time);
                    }
                }
                return longestDeliveryTime;
            },

            changeCount(new_count) {
                this.count = new_count;
            },

            addToCartWithCount(count) {
                if (!this.addToCartDisabled) {
                    this.changeCount(count);
                    this.addToCart();
                }
            },

            getAddOnVariationNane(addOnVariation) {
                let attributeNames = _.values(addOnVariation.attributes);
                return attributeNames.join(' - ');
            },

            addToCart : function() {

                let request = {
                    product_id: this.productId,
                    quantity: this.count,
                    variation: this.selections,
                };

                if (this.selected_variation_id != null) {
                    request.variation_id = this.selected_variation_id;
                }

                let add_ons = [];
                let allSelectedAddOns = this.getAllSelectedAddOns();

                for (let i in allSelectedAddOns) {

                    if (allSelectedAddOns[i] === false) continue;

                    let add_on_request = {};

                    if (allSelectedAddOns[i].variation_id) {
                        //Variation product
                        add_on_request.variation_id = allSelectedAddOns[i].variation_id;
                        add_on_request.product_id = allSelectedAddOns[i].product_id
                    } else {
                        //Basic product
                        add_on_request.product_id = allSelectedAddOns[i].id
                    }

                    add_ons.push(add_on_request);

                }

                request.add_ons = add_ons;

                const nonceCookieName = 'api_nonce';
                const hasCookieNonce = function() {
                    if (document.cookie.split(';').some((item) => item.trim().startsWith(`${nonceCookieName}=`))) {
                        return true;
                    } else {
                        return false;
                    }
                }

                const shouldUseCookieNonce = function(cookie, initTime) {
                    if (initTime < cookie.created) {
                        return true;
                    } else {
                        false;
                    }
                }

                let nonce = this.updatedNonce || this.nonce;

                if (hasCookieNonce()) {
                    const cookieNonce = JSON.parse(document.cookie
                        .split('; ')
                        .find(row => row.startsWith('api_nonce'))
                        .split('=')[1]
                    );

                    if (shouldUseCookieNonce(cookieNonce, this.componentInitTime.getTime())) {
                        nonce = cookieNonce.nonce;
                    }
                }

                let config = {
                    headers: {
                        'X-WP-Nonce': nonce,
                    },
                };

                axios.post('/wp-json/modeo/v2/cart/add_to_cart', request, config)
                .then(response => {

                    let totals = {
                        subtotal: response.data.subtotal,
                        subtotalTax: response.data.subtotal_tax,
                        total: response.data.total,
                        discount: response.data.discount_total,
                        discountTax: response.data.discount_tax,
                        count: response.data.cart_product_count,
                    };

                    this.$store.commit('setTotals', totals);

                    if (response.data.nonce) {
                        this.updatedNonce = response.data.nonce;
                        // set nonce cookie
                        let expiry = new Date();
                        const now = new Date();
                        expiry.setTime(expiry.getTime() + 2 * 24 * 60 * 60 * 1000);
                        const expires = 'expires=' + expiry.toUTCString();
                        const cookie = {
                            created: now.getTime(),
                            nonce: response.data.nonce,
                        }
                        document.cookie = `${nonceCookieName}=${JSON.stringify(cookie)};${expires};path=/;samesite=lax`;
                    }

                    if (response.data.status === true) {

                        let productAddedToCartData = {
                            productsAdded: this.count,
                            totalCartCount: response.data.cart_product_count,
                            notificationType: 'cart-updated',
                            autoHide: true,
                            orderType: this.orderType,
                        };

                        EventBus.$emit('notify', productAddedToCartData);
                    } else {

                        let messages = '';
                        if ( typeof response.data.status_messages !== 'undefined' && response.data.status_messages.length > 0 ) {
                            messages = ': ' + response.data.status_messages.join( "\n" );
                        }

                        let productAddedToCartData = {
                                message: this.orderType === 'offer' ? this.$modeoL10n.add_to_offer_failed + messages : this.$modeoL10n.add_to_cart_failed + messages,
                            notificationType: 'single-message',
                        };
                        EventBus.$emit('notify', productAddedToCartData);
                    }
                })
                .catch((error) => {
                    if ( error.response ) {

                        if ( error.response.status === 403 && error.response.data.code === 'Forbidden') {
                            let productAddedToCartData = {
                                message: this.$modeoL10n.offer_modification_failed,
                                notificationType: 'single-message',
                            };
                            EventBus.$emit( 'notify', productAddedToCartData );
                        } else {
                            let productAddedToCartData = {
                                message: this.orderType === 'offer' ? this.$modeoL10n.add_to_offer_failed : this.$modeoL10n.add_to_cart_failed,
                                notificationType: 'single-message',
                            };
                            EventBus.$emit( 'notify', productAddedToCartData );
                        }

                        // The request was made and the server responded with a status code
                        // that falls out of the range of 2xx
                        console.log( error.response.data );
                        console.log( error.response.status );
                        console.log( error.response.headers );
                    } else {
                        // Something happened in setting up the request that triggered an Error
                        console.log( 'Error', error.message );
                    }
                    console.log( error.config );
                });

            },

            clearSelections() {
                this.$refs.productMandatoryAddOns.setDefaultValues();
                this.$refs.productAddOns.clearSelections();
                this.$refs.productVariations.setDefaultValues();
                this.updateMandatoryAddOnTotal();
            },

            hasSelections() {
                return (this.productAddOns.length > 0 || this.variations.length > 0);
            },

            klarnaLocale() {
              if (this.$modeoL10n.lang == 'en') {
                return 'en-FI';
              } else {
                return 'fi-FI';
              }
            },

        },
    }
</script>
